const BASE = process.env.REACT_APP_API_URL || "";

export const api = {
  getDocuments: (params = {}) => {
    const q = new URLSearchParams(params).toString();
    return fetch(`${BASE}/api/documents${q ? "?" + q : ""}`).then(r => r.json());
  },
  createDocument: (doc) =>
    fetch(`${BASE}/api/documents`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(doc),
    }).then(r => r.json()),
  updateDocument: (id, fields) =>
    fetch(`${BASE}/api/documents/${id}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(fields),
    }).then(r => r.json()),
  deleteDocument: (id, force = false) =>
    fetch(`${BASE}/api/documents/${id}${force ? "/force" : ""}`, { method: "DELETE" }).then(r => r.json()),
  getSequence: (dept, docType, year) =>
    fetch(`${BASE}/api/sequence?dept=${dept}&docType=${docType}&year=${year}`).then(r => r.json()),
  getStats: () =>
    fetch(`${BASE}/api/stats`).then(r => r.json()),
};
